import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["source", "button"];

  copy() {
    navigator.clipboard.writeText(this.sourceTarget.value).then(() => {
      const originalContent = this.buttonTarget.innerHTML;
      this.buttonTarget.innerHTML = '<i class="bi bi-check"></i> Copied!';

      setTimeout(() => {
        this.buttonTarget.innerHTML = originalContent;
      }, 2000);
    });
  }
}
